import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { SchoolBreakAddView } from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/school-settings/breaks/add')({
  component: SchoolBreakAddView,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.add-new-school-break', { ns: 'schoolSettings' })
    ])
})
